module.exports = __webpack_public_path__ + "static/media/img-location-newtaipei-en.dbdf8ee2.svg";